export default __webpack_public_path__ + "static/media/consultPattern.5cb0bbd9.svg";